<template>
<div style="min-width: 1024px;max-width: 1680px;margin:0 auto;">
    <HeadTop />
    <div class="publish">
        <div class="left">
            <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="我发布的">
                    <a-empty v-if="total==0" />
                    <ul v-if="listData1.length>0">
                        <li class="li" v-for="(item,index) in listData1" :key="index">
                            <div class="mes">
                                <div class="mesLeft">
                                    <img class="userImg" v-if="item.userPhotoPath" :src="$userINfoBasePath+'/'+item.userPhotoPath" alt="">
                                    <img v-else class="userImg" src="../../assets/image/21.png" alt="" />
                                </div>
                                <div class="mesRight">
                                    <div class="name"><span>{{item.userName}}</span></div>
                                    <div class="content">{{item.content}}</div>
                                    <div class="dianzan">
                                        <template>
                                            <span key="message" class="goodMess">
                                                <a-icon type="message"
                                                @click="praiseMess(item)"
                                                />
                                                {{item.replyCount || 0}}
                                            </span>
                                            <span class="goodImg">
                                                <a-icon type="like"
                                                        :theme="item.isPraise === 1 ? 'filled' : 'outlined'"
                                                        @click="praise(item,1)" />
                                                {{item.praiseNumber || 0}}
                                            </span>
                                            <span class="goodImg">
                                                <a-icon type="delete"
                                                        @click="dele(item.id,1)" />
                                            </span>
                                        </template>
                                        <span class="dateTime">{{format.format(item.createDate)}}</span>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="selfReplay" v-show="index!==targetIndex">
                                <img class="userImg" v-if="userPhoto" :src="$userINfoBasePath+'/'+userPhoto" alt="" />
                                <img class="userImg" v-else src="../../assets/image/21.png" alt="" />
                                <span class="speak" @click="saySelf(index)">说下自己的看法吧</span>
                            </div> -->
                            <div class="selfReplay">
                                <!-- <div class="fb_box" v-show="index===targetIndex">
                                    <a-textarea v-model="item.comment" :auto-size="{ minRows: 4, maxRows: 4 }" />
                                    <div class="fb_d">
                                        <a-button class="fb" type="primary" @click="replyPublish(item,2)">发布</a-button>
                                    </div>
                                </div> -->
                                <!-- <div class="commentList" v-if="item.replys">
                                    <div class="mes1" v-for="(i,index) in item.replys" :key="index">
                                        <div class="mesLeft">
                                            <img class="userImg" v-if="i.reuserPhotoPath" :src="$userINfoBasePath+'/'+i.reuserPhotoPath" alt="" />
                                            <img class="userImg" v-else src="../../assets/image/21.png" alt="" />
                                        </div>
                                        <div class="mesRight">
                                            <div class="name"><span>{{i.reuserName}}</span>@<span></span><span>{{i.userName}}</span></div>
                                            <div class="content">{{i.content}}</div>
                                            <div class="dianzan">
                                                <template>
                                                    <span key="message" class="goodMess">
                                                        <a-icon type="message"
                                                        @click="praiseMess(i)"
                                                        />
                                                    </span>
                                                    <span key="" class="goodImg">
                                                        <a-icon type="like"
                                                                :theme="i.isPraise === 1 ? 'filled' : 'outlined'"
                                                                @click="praise(i,2)" />
                                                        {{i.praiseNumber || 0}}
                                                    </span>
                                                    <span class="goodImg">
                                                        <a-icon type="delete"
                                                                @click="dele(i.id,2)" />
                                                    </span>
                                                </template>
                                                <span class="dateTime">{{format.format(i.createDate)}}</span>
                                            </div>
                                            <ul class="comment_sl" style="display:none;">
                                                <li class="mes_two">
                                                    <div class="mes_twoLeft">
                                                        <img class="userImg" src="../../assets/teacherRoad/10.png" alt="" />
                                                    </div>
                                                    <div class="mes_twoRight">
                                                        <div><span class="name">测试出</span> <img class="img_s" src="../../assets/teacherRoad/@2x.png" alt="" /> <span class="someBody">马环虹</span></div>
                                                        <div class="content">{{item.content}}</div>
                                                        <div class="dianzan">
                                                            <template>
                                                                <span key="message" class="goodMess">
                                                                    <a-icon type="message"
                                                                    @click="praiseMess(item)"
                                                                    />
                                                                </span>
                                                                <span key="" class="goodImg">
                                                                    <a-icon type="like"
                                                                            :theme="item.isPraise === 1 ? 'filled' : 'outlined'"
                                                                            @click="praise(item,1)" />
                                                                    {{item.praiseNumber || 0}}
                                                                </span>
                                                            </template>
                                                            <span class="dateTime">{{format.format(item.createDate)}}</span>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </li>
                    </ul>
                    <div style="text-align:center;margin-top:20px;height:50px;">
                    <a-config-provider>
                    <a-pagination
                        show-quick-jumper
                        :default-current="1"
                        :page-size="pageSize"
                        @change="handleListChange"
                        show-less-items
                        :total=total />
                    </a-config-provider>
                </div>
                </a-tab-pane>
            </a-tabs>
        </div>
        <div class="right">
            <div class="top">
                <div class="user">
                    <img class="userImg" src="../../assets/teacherRoad/10.png" alt="" />
                    <span class="userName">{{userName}}</span>
                </div>
                <div class="userDetail">
                    <div class="left">
                            <div class="num">{{userMess.pushCount || 0}}</div>
                            <div class="text" @click="goPublish">我发布的</div>
                        </div>
                        <div class="right">
                            <div class="num">{{userMess.praiseNum || 0}}</div>
                            <div class="text">获赞</div>
                        </div>
                </div>
            </div>
            <div class="bot">
                <div class="myReplay">
                    <img class="messImg" src="../../assets/teacherRoad/26.png" alt="" />
                    <span class="text">我的评论</span>
                </div>
                <ul class="replyList">
                    <li v-for="(item,index) in commentListRight" :key="index">
                        <div class="name_rp">
                            <span class="na">{{item.recuserName}}</span>
                            <span class="re">回复{{item.userName}}</span>
                        </div>
                        <div class="content">{{item.commentContent}}</div>
                        <div class="mainCont">
                            <div class="name_cont">{{item.content}}</div>
                            <!-- <div class="name_cont">
                                {{item.content}}
                            </div> -->
                        </div>
                    </li>
                </ul>
                <div class="lookAll" @click="lookAllFun">查看全部</div>
            </div>
        </div>
    </div>
        <!-- 查看全部交流广场回答 -->
        <a-modal v-model="lookMoreModal"
                width="1100px"
                title="全部回答"
                forceRender
                destroyOnClose
                footer="">
        <div class="mesMore">
            <a-list item-layout="vertical"
                    size="large"
                    :data-source="moreMess">
            <a-list-item slot="renderItem"
                        key="item.title"
                        slot-scope="item, index">
                <a-list-item-meta>
                <span slot="title"
                        :href="$userINfoBasePath+item.userPhotoPath">{{ item.userName }} <span v-if="item.reuserName">@</span> {{item.reuserName}}</span>
                <a-avatar slot="avatar"
                            :src="$userINfoBasePath+'/'+item.userPhotoPath" />
                </a-list-item-meta>
                <p class="content">{{item.content}}</p>
                <div class="time">

                    <span class="dianzanMore">
                        <template>
                            <span key="message">
                                <a-icon type="message" @click="Infobox(item,2)" />
                                {{ item.replyCount || 0 }}
                            </span>
                            <span class="goodMess">
                                <a-icon type="like" :theme="item.isPraise === 1 ? 'filled' : 'outlined'" @click="praise(item,2)" />
                                {{ item.praiseNumber || 0 }}
                            </span>
                        </template>
                    </span>
                    <span class="dzTime">{{format.format(item.createDate)}}</span>
                </div>
                <div class="replyMes" v-if="item.subReplyList&&item.subReplyList.length>0">
                    <div class="replyMesDetail"
                        v-for="(t,index) in item.subReplyList"
                        :key="index">
                        <div>
                            <a-avatar class="replayUserImg"
                                    slot="avatar"
                                    :src="$userINfoBasePath+'/'+t.userPhotoPath" />
                            <span class="replayName">{{t.userName}}</span>
                            <img class="img_img"
                                src="../../assets/imgs/teacherRoadImg/@.png"
                                alt="" />
                            <span class="replayUserName">{{t.reuserName}}</span>
                        </div>
                        <p class="replyContent">{{t.content}}</p>
                        <div class="replyTime">
                            <span class="dianzan">
                            <template>
                                <span key="message"
                                    class="goodMess">
                                    <a-icon type="message" @click="Infobox(t,2)" />
                                </span>
                                <span class="likeo">
                                    <a-icon type="like"
                                            :theme="t.isPraise === 1 ? 'filled' : 'outlined'"
                                            @click="praise(t,2)" />
                                    {{t.praiseNumber || 0}}
                                </span>
                            </template>
                            </span>
                            <span class="time">{{format.format(t.createDate)}}</span>
                        </div>
                    </div>
                </div>
            </a-list-item>
            </a-list>
        </div>
        </a-modal>
        <!--回答弹窗-->
        <a-modal v-model="answerModal"
                style="z-index:999999;"
                width="1100px"
                destroyOnClose
                title=""
                footer="">
        <div class="answerMes">
            <div><span class="answerText">回答</span><span class="answerName">{{replyMess.userName || replyMess.reuserName}}</span></div>
            <div class="answerTitle">{{replyMess.content|| replyMess.replyContent}}</div>
            <div class="answerBgc">
            <a-textarea class="area" v-model="myReplayValue" :auto-size="{ minRows: 6, maxRows: 10 }" />
            </div>
        </div>
        <div class="askHelp">
            <a-button class="ask" @click="replyPublish(replyMess,2)">发布</a-button>
        </div>
        </a-modal>
</div>
</template>

<script>
import HeadTop from '@/components/HeadTop.vue'
import format from '@/utils/format.js'
export default {
    name: 'myPublish',
    data(){
        return {
            format,
            userName: this.$getUserInfo().name,
            userPhoto: this.$getUserInfo().photo,
            resBasePath: this.$resBasePath,
            listData1: [],
            type: 2,
            targetIndex: -1,
            pageNum: 1,
            pageSize: 5,
            userMess: {},
            commentListRight: [],//我的评论
            lookMoreModal:false,
            moreMess: [],
            answerModal: false,
            replyMess: {},
            myReplayValue: '',
            total: 0
        }
    },
    mounted(){
        this.getDataList()
        this.getMyCommentPage()
        this.getTeacherCommentList()
    },
    methods:{
        //老师评论信息
        getTeacherCommentList(){
            this.$fetch({
                url: this.$baseUrl + 'ebook/teacher/exchangeSpace/getPushCountByUserId',
                body: {
                    userId: this.$getUserInfo().id
                }
            }).done(res =>{
                if(res && res.success && res.resultCode === 0){
                    this.userMess = res.resultData
                }
            })
        },
        getMyCommentPage(){
            const param = {
                type: 1,
                userId: this.$getUserInfo().id,
                pageSize: 2,
                pageNum: 1
            }
            this.$fetch({
                url: this.$baseUrl + 'ebook/teacher/exchangeSpace/getMyCommentPage',
                body: param
            }).done(res => {
                if(res && res.success && res.resultCode === 0){
                    this.commentListRight = res.resultData.list
                }
            })
        },
        getDataList () {
            const param = {
                userId: this.$getUserInfo().id,
                type: this.type,
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }
            this.$fetch({
                url: this.$baseUrl + 'ebook/teacher/exchangeSpace/exchangeSpaceList',
                body: param
            }).done(res => {
                if (res && res.success && res.resultCode === 0) {
                    this.listData1 = res.resultData.list
                    this.total = res.resultData.total
                }
            })
        },
        // saySelf(index){
        //     this.myReplayValue = ''
        //     this.targetIndex = index
        // },
        //点赞功能
        praise (item, type) {
            const url = item.isPraise === 1 ? 'ebook/teacher/exchangeSpace/exchangeSpaceCancelClickPraise' : 'ebook/teacher/exchangeSpace/exchangeSpaceClickPraise'
            const param = {
                id: item.id,
                type: type,
                userId: this.$getUserInfo().id
            }
            this.$fetch({
                url: this.$baseUrl + url,
                body: param
            }).done(res => {
                if (res && res.success && res.resultCode === 0) {
                //item.isPraise === 1 ? (item.isPraise = 0,item.praiseNumber-=1) : (item.isPraise = 1,item.praiseNumber-=1)
                // console.log(item,type)
                if (type === 1) {
                    if (item.isPraise === 1) {
                    item.isPraise = 0
                    item.praiseNumber = parseInt(item.praiseNumber) - 1
                    } else {
                    item.isPraise = 1
                    item.praiseNumber = parseInt(item.praiseNumber) + 1
                    }
                } else {
                    if (item.isPraise === 1) {
                    item.isPraise = 0
                    item.praiseNumber = parseInt(item.praiseNumber) - 1
                    } else {
                    item.isPraise = 1
                    item.praiseNumber = parseInt(item.praiseNumber) + 1
                    }
                }
                }
            })
        },

        dele (id, type) { //删除
            const param = {
                id: id,
                type: type
            }
            this.$fetch({
                url: this.$baseUrl + 'ebook/teacher/exchangeSpace/deleteExchangeSpaceComment',
                body: param
            }).loading(
                () => (this.loading = true),
                () => (this.loading = false)
            ).done(res => {
                if(res && res.success && res.resultCode === 0){
                    this.$message.success('删除成功')
                    this.getDataList()
                }
            })
        },
        praiseMess(item){
            this.lookMoreModal = true
            const param = {
                id: item.id,
                userId: item.userId,
                pageSize: 10,
                pageNum: 1
            }
            this.$fetch({
                url: this.$baseUrl + 'ebook/teacher/exchangeSpace/getExchangeSpaceReplyPage',
                body:param
            }).done(res => {
                if(res && res.success && res.resultCode === 0){
                    if(res.resultData!= null){
                        this.moreMess = res.resultData.list
                    }
                }
            })
        },
        lookAllFun(){
            this.$router.push({name: 'myComment'})
        },
        // 点击信息评论弹框
        Infobox (item, type) {
            // console.log(item,type)
            this.replyMess = item
            this.typeMess = type
            this.askValue = ''
            this.answerModal = true
        },
        //评论回复
        replyPublish(item,type){
            let content = '', parentId = '', id = ''
            if (type == 1) {
                content = this.myReplayValue
                parentId = 0
                id = item.id
            } else {
                content = this.myReplayValue
                parentId = item.id
                id = item.rootId
            }
            const param = {
                type: type,
                userId: this.$getUserInfo().id,
                reUserId: item.userId, // 被回复ID
                rootId: id, // 顶层互动提问id
                parentId: parentId, // 被评论回复id type为1 时传 0
                content: content // 评论内容
            }
            this.$fetch({
                    url: this.$baseUrl + 'ebook/teacher/exchangeSpace/commentReply',
                    body: param
                }).done(res => {
                    if (res && res.success && res.resultCode === 0) {
                        this.$message.success('发布成功')
                        this.lookMoreModal = false
                        this.answerModal = false
                        this.getDataList()
                        this.targetIndex = -1
                    }
                })
        },
        handleListChange (current, pageSize) {
            this.pageNum = current
            this.pageSize = pageSize
            this.getDataList()
        },
        goPublish(){
            this.$router.push({name: 'myPublish'})
        }
    },
    components:{
        HeadTop
    }
}
</script>

<style lang="less" scoped>
    ul,li{
        list-style: none;
        margin: 0;
        padding: 0;
    }
    .publish{
        //width: 1240px;
        margin: 0 auto;
        display: flex;
        /deep/.ant-tabs-bar{
            border-bottom: 1px solid #f0f0f0;
        }
        .left{
            //width: 900px;
            flex: 1;
            background: #fff;
            height: 100%;
            border-radius: 8px;
            ul{
                width: 100%;
                .li{
                    min-height: 220px;
                    width: 100%;
                    // border-bottom: 2px dotted #E6DDD0;
                    border-bottom: 1px solid #E6DDD0;
                    .mes{
                        width: 100%;
                        margin: 0 20px 0 20px;
                        border-bottom: 2px dotted #E6DDD0;
                        display: flex;
                        .mesLeft{
                            width: 50px;
                            height: 100%;
                            .userImg{
                                margin-top: 30px;
                                width: 36px;
                                height: 36px;
                                border-radius: 50%;
                            }
                        }
                        .mesRight{
                            width: 100%;
                            height: 100%;
                            padding: 30px 0px 0px 15px;
                            .name{
                                font-size: 16px;
                                font-family: PingFangSC-Semibold, PingFang SC;
                                font-weight: 600;
                                color: #000000;
                                line-height: 24px;
                            }
                            .content{
                                font-size: 18px;
                                font-family: STSongti-SC-Regular, STSongti-SC;
                                font-weight: 400;
                                color: #040506;
                                margin-top: 6px;
                            }
                            .dianzan{
                                margin: 10px 0px;
                                .goodMess{

                                }
                                .goodImg{
                                    margin-left: 30px;
                                }
                                .dateTime{
                                    float: right;
                                    margin-right: 40px;
                                }
                            }
                        }
                    }
                    .selfReplay{
                        margin-left: 100px;
                        margin-top: 20px;
                        margin-bottom: 30px;
                        margin-right: 50px;
                        position: relative;
                        .userImg{
                            width: 32px;
                            height: 32px;
                            margin-top: -5px;
                            border-radius: 50%;
                        }
                        .speak{
                            cursor: pointer;
                            display: inline-block;
                            width: 710px;
                            height: 32px;
                            line-height: 32px;
                            background: #F6F6F6;
                            border-radius: 4px;
                            margin-left: 7px;
                            margin-top: 5px;
                            font-size: 14px;
                            font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
                            font-weight: 400;
                            color: #7F7F7F;
                            text-indent: 25px;
                        }
                        .fb_box{
                            .fb_d{
                                height: 35px;
                                margin-top: 10px;
                                text-align: right;
                                .fb{
                                    width: 80px;
                                    height: 24px;
                                    line-height: 24px;
                                    border-radius: 2px;
                                }
                            }
                        }
                        .commentList{
                            width: 750px;
                            .mes1{
                                width: 800px;
                                margin: 0 auto;
                                // border-bottom: 2px dotted #E6DDD0;
                                display: flex;
                                .mesLeft{
                                    width: 50px;
                                    height: 100%;
                                    .userImg{
                                        width: 32px;
                                        height: 32px;
                                        border-radius: 50%;
                                    }
                                }
                                .mesRight{
                                    width: 700px;
                                    height: 100%;
                                    // padding: 0px 0px 0px 15px;
                                    .name{
                                        font-size: 16px;
                                        font-family: PingFangSC-Semibold, PingFang SC;
                                        font-weight: 600;
                                        color: #000000;
                                        line-height: 24px;
                                    }
                                    .content{
                                        font-size: 18px;
                                        font-family: STSongti-SC-Regular, STSongti-SC;
                                        font-weight: 400;
                                        color: #040506;
                                        margin-top: 6px;
                                    }
                                    .dianzan{
                                        margin: 10px 0px;
                                        .goodMess{

                                        }
                                        .goodImg{
                                            margin-left: 30px;
                                        }
                                        .dateTime{
                                            float: right;
                                        }
                                    }
                                    .comment_sl{
                                        background: #f6f6f6;
                                        width: 700px;
                                        display: block;
                                        padding: 0px 20px 20px 20px;
                                        .mes_two{
                                            width: 660px;
                                            padding-top: 20px;
                                            border-bottom: 2px dotted #E6DDD0;
                                            display: flex;
                                            .mes_twoLeft{
                                                width: 50px;
                                                height: 100%;
                                                .userImg{
                                                    width: 32px;
                                                    height: 32px;
                                                    border-radius: 50%;
                                                }
                                            }
                                            .mes_twoRight{
                                                width: 640px;
                                                height: 100%;
                                                .name{
                                                    font-size: 16px;
                                                    font-family: PingFangSC-Semibold, PingFang SC;
                                                    font-weight: 600;
                                                    color: #000000;
                                                    line-height: 24px;
                                                }
                                                .img_s{
                                                    width: 22px;
                                                    height: 22px;
                                                    margin: -4px 5px 0px 5px;
                                                }
                                                .someBody{
                                                    font-size: 16px;
                                                    font-family: PingFangSC-Regular, PingFang SC;
                                                    font-weight: 400;
                                                    color: #BDBDBD;
                                                    line-height: 24px
                                                }
                                                .content{
                                                    font-size: 18px;
                                                    font-family: STSongti-SC-Regular, STSongti-SC;
                                                    font-weight: 400;
                                                    color: #040506;
                                                    margin-top: 6px;
                                                }
                                                .dianzan{
                                                    margin: 10px 0px;
                                                    .goodMess{

                                                    }
                                                    .goodImg{
                                                        margin-left: 30px;
                                                    }
                                                    .dateTime{
                                                        float: right;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .right{
            width: 310px;
            height: 200px;
            background: #fff;
            margin-left: 30px;
            .top{
                height: 200px;
                background: #fff;
                .user{
                    width: 150px;
                    margin: 0 auto;
                    padding-top: 30px;
                    // padding: 30px 90px 0px 30px;
                    .userImg{
                       width: 44px;
                       height: 44px;
                       text-align: center;
                       border-radius: 50%;
                       margin-top: -8px;
                    }
                    .userName{
                        width: 60px;
                        height: 40px;
                        font-size: 20px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #000000;
                        line-height: 40px;
                        margin-left: 20px;
                    }
                }
                .userDetail{
                    display: flex;
                    margin-top: 30px;
                    .left,.right{
                        width: 50%;
                        height: 60px;
                        text-align: center;
                        .num{
                            font-size: 24px;
                            font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
                            font-weight: bold;
                            font-weight: 600;
                            color: #A3AF90;
                            line-height: 30px;
                        }
                        .text{
                            font-size: 12px;
                            font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
                            font-weight: bold;
                            font-weight: 400;
                            color: #000000;
                            line-height: 20px;
                            margin-top: 10px;
                        }
                    }
                    .left{
                        border-right: 1px solid #E6DDD0;
                    }
                    .right{
                        margin-left: 0px;
                    }
                }
            }
            .bot{
                height: 500px;
                background: #fff;
                margin-top: 30px;
                padding: 30px;
                .myReplay{
                    height: 30px;
                    line-height: 30px;
                    .messImg{
                        width: 16px;
                        height: 14px;
                        margin-top: -4px;
                    }
                    .text{
                        margin-left: 10px;
                        font-size: 16px;
                        font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
                        font-weight: 400;
                        color: #999999;
                        line-height: 20px;
                    }
                }
                .replyList{
                    li{
                        margin-top: 5px;
                        height: 180px;
                        border-bottom: 1px solid #E6DDD0;
                        .name_rp{
                            margin-top: 5px;
                            height: 20px;
                            line-height: 20px;
                            .na{
                                font-size: 12px;
                                font-family: PingFangSC-Semibold, PingFang SC;
                                font-weight: 600;
                                color: #000000;
                                line-height: 20px;
                            }
                            .re{
                                margin-left: 10px;
                                font-size: 12px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #BDBDBD;
                                line-height: 20px;
                            }
                        }
                        .content{
                            font-size: 14px;
                            font-family: STSongti-SC-Regular, STSongti-SC;
                            font-weight: 400;
                            color: #040506;
                            line-height: 32px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: vertical;
                        }
                        .mainCont{
                            width: 250px;
                            background: #f6f6f6;
                            border-radius: 4px;
                            height: 100px;
                            padding: 10px 20px;
                            .name{
                                font-size: 12px;
                                font-family: PingFangSC-Semibold, PingFang SC;
                                font-weight: 600;
                                color: #000000;
                                height: 25px;
                                line-height: 25px;
                            }
                            .name_cont{
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 3;
                                -webkit-box-orient: vertical;
                            }
                        }
                    }
                }
                .lookAll{
                    cursor: pointer;
                    margin-top: 10px;
                    text-align: center;
                    width: 100%;
                    height: 40px;
                    font-size: 14px;
                    font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
                    font-weight: 500;
                    color: @primary-color;
                    line-height: 40px;
                }
            }
        }
    }
        //lookmore
    .mesMore {
        min-height: 160px;
        padding: 20px;
        background: #fff;
        overflow-y: auto;
    }
    .dianzanMore {
        width: 150px;
        text-align: right;
        .goodImg {
            width: 20px;
            height: 20px;
            margin-top: -8px;
            cursor: pointer;
        }
        .goodMess{
            margin-left: 20px;
        }
    }
    .dzTime{
        float: right;
    }
    .ant-list-split .ant-list-item{
        border-bottom: 1px solid #e8e8e8;
    }
    .replyMes{
        padding: 20px;
        margin-top: 10px;
        padding-left: 40px;
        background: #f6f6f6;
        .replyMesDetail{
            padding: 10px 0px;
            border-bottom: 2px dotted #E6DDD0;
            .replayName{
                margin-left: 10px;
            }
            .img_img{
                width: 20px;
                height: 20px;
                margin: 0px 10px;
            }
            .replyContent{
                padding: 0;
                margin: 0;
                height: 30px;
                line-height: 30px;
            }
            .time{
                float: right;
            }
            .likeo{
                margin-left: 20px;
            }
        }
    }

        .askHelp{
        height: 40px;
        line-height: 40px;
        text-align: right;
        .area{
            margin-top: 5px;
        }
        .ask{
            margin-top: 15px;
            width: 80px;
            height: 24px;
            line-height: 24px;
            border-radius: 2px;
            background: @primary-color;
            color:#fff;
        }
    }
    .replyMes{
        padding: 20px;
        margin-top: 10px;
        padding-left: 40px;
        background: #f6f6f6;
        .replyMesDetail{
            padding-bottom: 10px;
            border-bottom: 2px dotted #E6DDD0;
            .replayName{
                margin-left: 10px;
            }
            .img_img{
                width: 20px;
                height: 20px;
                margin: 0px 10px;
            }
            .replyContent{
                padding: 0;
                margin: 0;
                height: 30px;
                line-height: 30px;
            }
            .time{
                float: right;
            }
            .likeo{
                margin-left: 20px;
            }
        }
    }
</style>
